/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { setTimeShow, setStep, handleNextStep, handleStepBack, setIsCar, getClaimDamagePhotoTypes, setFNOLWhat, completeStep } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { navigateTo } from '../../../actions/navigationActions';
import { FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { CLAIM_TYPE_GLASS } from '../../../constants/constants';

class FnolStep3Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            DescriptionWhatDisabled: false,
            DescriptionWhatSubmitted: false,
            incidentDescriptionWhere: "",
            incidentDescriptionWhat: this.props.claimSubmit.whatDescription,
        }
        this.handleChangeDescriptionWhat = this.handleChangeDescriptionWhat.bind(this);
        this.checkWhatSubmit = this.checkWhatSubmit.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.handleSubmitHow = this.handleSubmitHow.bind(this);
        this.handleIsDrivable = this.handleIsDrivable.bind(this);
        this.checkMobileRedirect = this.checkMobileRedirect.bind(this);
    }

    async handleIsDrivable(e: any) {
        this.setState({ DescriptionWhatSubmitted: true });
        if (this.state.incidentDescriptionWhat) {
            this.props.dispatchCompleteStep();
            this.props.dispatchSetStep(4, 1);
            await this.setState({
                currentStep: 4,
            })

            if (this.props.claimSubmit.selectedCover.product === 1 || this.props.claimSubmit.selectedCover.product === 2) {
                await this.setState({
                    isCar: true,
                })
                await this.props.dispatchSetIsCar(true);
            }
            else if (this.props.claimSubmit.selectedCover.product === 7) {
                await this.setState({
                    isCar: false,
                })
                await this.props.dispatchSetIsCar(false);
            }
            if (!this.props.claimSubmit.hasDamageSelected) {
                this.props.claimSubmit.isCar ? await this.props.dispatchGetClaimDamagePhotoTypes(6) : await this.props.dispatchGetClaimDamagePhotoTypes(7);
            }
            this.props.dispatchCompleteStep();
            this.props.dispatchSetStep(4, 1);
            
        }
        else {
            this.setState({ DescriptionWhatDisabled: true });
        }
    }

    async handleSubmitHow() {
        this.setState({ DescriptionWhatSubmitted: true });
        if (this.state.incidentDescriptionWhat) {
            await this.props.dispatchSetFNOLWhat(this.state.incidentDescriptionWhat)
            if (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS && !this.props.claimSubmit.hasDamageSelected) {
                this.props.claimSubmit.isCar ? await this.props.dispatchGetClaimDamagePhotoTypes(6) : await this.props.dispatchGetClaimDamagePhotoTypes(7);
            }
            this.props.dispatchHandleNextStep();
            this.checkMobileRedirect();
        } else {
            this.setState({ DescriptionWhatDisabled: true });
        }
    }


    checkMobileRedirect() {
        if (isMobile && (this.props.claimSubmit.lastCompletedStep > (this.props.claimSubmit.selectedClaimStep.step))) {
            this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
            this.props.dispatchSetStep(this.props.claimSubmit.lastCompletedStep, this.props.claimSubmit.lastCompletedSubStep);
        }
    }

    handleStepBack() {
        this.setState({ DescriptionWhatDisabled: false });
        const currentStep = this.props.claimSubmit.selectedClaimStep.step;
        if (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) {
            this.props.dispatchSetStep(1, 4);
        }
        else {
            this.props.dispatchHandleStepBack();
        }
    }

    checkWhatSubmit() {

        if (this.state.incidentDescriptionWhat) {
            this.setState({ DescriptionWhatDisabled: false });
        } else {
            this.setState({ DescriptionWhatDisabled: true });
        }
    }

    handleChangeDescriptionWhat(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
        if (this.state.DescriptionWhatSubmitted) {
            this.checkWhatSubmit();
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {
        return (<div className="col ssp-container-fnol-what-happened ssp-container-fnol-step-header-padding ssp-form">
                    <div className="row noma">
                        <div className="col-12 nopa ssp-header-fnol-ssp-header-fnol-what-happened">
                            <div className="row noma">
                        <div className="fnol-step-header-icon-area">
                            <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                                </div>
                                <div className="col fnol-step-header-title-area">
                                {
                                    (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS) &&
                                    <h3>What happened</h3>
                                }
                                {
                                    (this.props.claimSubmit.claimType != CLAIM_TYPE_GLASS) &&
                                    <h3>Tell us what happened</h3>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row noma">
                        <div className="col-12 fnol-steps-form-section-holder">
                            <hr className="hr-minus21px" />
                            <div className={'form-group ' + (this.state.DescriptionWhatSubmitted && !this.state.incidentDescriptionWhat ? ' has-error' : '')}>
                            <p className="fnol-what-happened-intro-p">How did this happen (share as much info as possible)</p>
                                <textarea id="incidentDescriptionWhat" name="incidentDescriptionWhat" rows={4} cols={50} className="ssp-form-textarea" placeholder="Tap here to start typing" value={this.state.incidentDescriptionWhat} onChange={this.handleChangeDescriptionWhat} />
                                {this.state.DescriptionWhatSubmitted && !this.state.incidentDescriptionWhat &&
                                    <div className="form-inline-error">Description of how it happened is required</div>
                                }
                            </div>
                            <div className="col-12 nopa fnol-steps-buttonholder fnol-steps-what-happened-new-button-holder">
                                <button className="btn btn-solid-red fnol-buttonreverse-button-next" disabled={this.state.DescriptionWhatDisabled} onClick={this.handleSubmitHow}>Next</button>
                                <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleStepBack}>Back</button>
                            </div>
                        </div>
                    </div>
            </div>)
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchSetIsCar: (isCar) => dispatch(setIsCar(isCar)),
        dispatchGetClaimDamagePhotoTypes: (riskItemType) => dispatch(getClaimDamagePhotoTypes(riskItemType)),
        dispatchSetFNOLWhat: (WhatDescription) => dispatch(setFNOLWhat(WhatDescription)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchCompleteStep: () => dispatch(completeStep()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep3Sub1)